export default __webpack_public_path__ + "static/144-min-min-e1c7a1440e8865b985bb8584b461908e.jpg";